import {
  collection,
  doc,
  onSnapshot,
  setDoc,
  updateDoc,
  deleteDoc,
  Unsubscribe
} from 'firebase/firestore';
import { db } from './firebase';
import { NewsItem } from '../types';
import { sanitizeFirestoreData } from '../utils/sanitizeFirestore';

const COLLECTION_NAME = 'news';

export function subscribeNews(
  onData: (news: NewsItem[]) => void,
  onError?: (error: Error) => void
): Unsubscribe {
  const newsRef = collection(db, COLLECTION_NAME);
  return onSnapshot(
    newsRef,
    (snapshot) => {
      const news: NewsItem[] = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...(docSnap.data() as Omit<NewsItem, 'id'>)
      }));
      news.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      onData(news);
    },
    (err) => {
      console.error('Error listening to news collection:', err);
      if (onError) onError(err);
    }
  );
}

export async function addNewsItem(newsData: Omit<NewsItem, 'id' | 'createdAt'>): Promise<string> {
  const newRef = doc(collection(db, COLLECTION_NAME));
  const newItem: NewsItem = {
    ...newsData,
    id: newRef.id,
    createdAt: new Date().toISOString().split('T')[0]
  };
  await setDoc(newRef, sanitizeFirestoreData(newItem));
  return newRef.id;
}

export async function updateNewsItem(id: string, updates: Partial<NewsItem>): Promise<void> {
  const docRef = doc(db, COLLECTION_NAME, id);
  await updateDoc(docRef, sanitizeFirestoreData(updates));
}

export async function deleteNewsItem(id: string): Promise<void> {
  const docRef = doc(db, COLLECTION_NAME, id);
  await deleteDoc(docRef);
}
